import { Injectable } from '@angular/core';
import { PaymentResult, PaymentStrategy } from './payment-strategy.interface';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {

   private currentStrategy: PaymentStrategy | null = null;

  constructor() { }

  useStrategy(strategy: PaymentStrategy): void {
    this.currentStrategy = strategy;
  }

  async initializePayment(config: any): Promise<boolean> {
    if (!this.currentStrategy) {
      throw new Error('No se ha seleccionado una estrategia de pago.');
    }
    return await this.currentStrategy.initialize(config);
  }

  async processPayment(amount: number, metadata: any): Promise<PaymentResult> {
    if (!this.currentStrategy) {
      throw new Error('No se ha seleccionado una estrategia de pago.');
    }
    return await this.currentStrategy.processPayment(amount, metadata);
  }
}
